export interface AppConfiguration {
  currentLanguage: string;
  customerId: number;
  globalApiUrl: string;
  identityUrl: string;
  isBrowserStorageUsed: boolean;
  isBrowserTabsSynchronizationUsed: boolean;
  tenant: string;
}

export const DEFAULT_CONFIG = {
  currentLanguage: document.documentElement.lang,
  customerId: -1,
  globalApiUrl: 'https://we-test-api.oriflame.com/uat',
  identityUrl: 'https://identity-we-uat.oriflame.com',
  isBrowserStorageUsed: true,
  isBrowserTabsSynchronizationUsed: true,
  tenant: 'uk',
};
